import { absoluteUrl } from './siteConfig';

const PAGE_PATH = '/pocketbillingai';
const GOOGLE_PLAY_APP_URL =
  'https://play.google.com/store/apps/details?id=in.restroai.lite';
const OG_IMAGE = absoluteUrl('/seo/pocketbillingai-og.png');

export const POCKET_BILLING_AI_KEYWORDS = [
  'POS software India',
  'Retail POS billing software',
  'Cloud billing software',
  'Online billing software',
  'Invoice billing software',
  'GST POS software',
  'GST invoice app',
  'Bill generation software',
  'Bill making app',
  'Invoice maker app',
  'Retail management software',
  'Shop accounting software',
  'Business management software',
  'Store management software',
  'Multi-store billing software',
  'Multi-shop billing software',
  'Customer management software',
  'Customer ledger app',
  'Expense management software',
  'Purchase management software',
  'Sales management software',
  'Daily sales report software',
  'Profit and loss software',
  'Cash management software',
  'Shopkeeper app',
  'Retail shop software',
  'Grocery shop software',
  'Medical store billing software',
  'Pharmacy billing software',
  'Chemist billing software',
  'Electronics shop billing software',
  'Garment shop billing software',
  'Hardware shop billing software',
  'Sweet shop billing software',
  'Bakery billing software',
  'Mobile shop billing software',
  'Wholesale billing software',
  'Distributor billing software',
  'Trading business billing software',
  'SME billing software',
  'MSME billing software',
  'Business invoicing software',
  'Quick billing software',
  'Fast billing app',
  'Digital invoice software',
  'Paperless billing software',
  'Smart POS software',
  'AI powered POS software',
  'AI invoice generator',
  'AI retail software',
  'Voice enabled billing app',
  'Hindi billing software',
  'English Hindi billing software',
  'Local language billing software',
  'Thermal printer compatible billing software',
  'Bluetooth printer billing app',
  'Barcode scanner billing software',
  'QR code billing software',
  'UPI billing software',
  'UPI invoice software',
  'WhatsApp invoice generator',
  'WhatsApp bill sharing software',
  'PDF invoice generator',
  'GST bill generator',
  'GST ready billing software',
  'Indian billing software',
  'Made in India billing software',
  'Best billing app for shop owners',
  'Best GST billing software India',
  'Best billing software for kirana store',
  'Best retail billing software',
  'Affordable billing software India',
  'Free GST billing app',
  'Billing software under 500 rupees',
  'Small shop billing software',
  'Retail inventory management software',
  'Stock and billing software',
  'Inventory and billing software',
  'Sales and inventory software',
  'Retail ERP software',
  'Shop POS system',
  'Billing machine software',
  'Cash counter billing software',
  'Retail checkout software',
  'GST software for retailers',
  'GST software for shopkeepers',
  'Business software India',
  'Shop software India',
  'Invoice software for retailers',
  'Billing app for Android',
  'Offline POS software',
  'Offline GST billing app',
  'Cloud POS software India',
  'Retail automation software',
  'Digital shop management software'
].join(', ');

export const pocketBillingAiSeo = {
  title:
  'PocketBillingAI | GST Billing Software, Kirana Billing App & Retail POS Software India',
  
  description:
  'PocketBillingAI is an AI-powered GST billing software for kirana stores, retail shops, restaurants, pharmacies, and small businesses in India. Create GST invoices, manage inventory, barcode billing, udhar khata, WhatsApp invoices, GSTR reports, thermal printer billing, and voice billing in Hindi. Works offline on Desktop and Android. Plans starting at ₹500/month.',
  
  keywords: POCKET_BILLING_AI_KEYWORDS,
  
  canonical: absoluteUrl(PAGE_PATH),
  
  ogImage: OG_IMAGE,
  
  ogType: 'website',
  };
  

export function pocketBillingAiJsonLd() {
  const url = absoluteUrl(PAGE_PATH);
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'PocketBillingAI',
      alternateName: ['Pocket Billing AI', 'PocketBilling AI', 'RestroAI PocketBillingAI'],
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Windows, macOS, Android',
      description: pocketBillingAiSeo.description,
      url,
      downloadUrl: GOOGLE_PLAY_APP_URL,
      installUrl: GOOGLE_PLAY_APP_URL,
      image: OG_IMAGE,
      inLanguage: ['en', 'hi', 'mr', 'bn', 'te', 'ta', 'gu', 'kn', 'ml', 'pa'],
      offers: {
        '@type': 'Offer',
        price: '500',
        priceCurrency: 'INR',
        priceValidUntil: '2027-12-31',
        availability: 'https://schema.org/InStock',
        url,
      },
      provider: {
        '@type': 'Organization',
        name: 'RestroAI',
        url: absoluteUrl('/'),
      },
      featureList: [
        'Offline billing for kirana and retail shops',
        'GST compliance and GSTR-style reports',
        'AI speech billing with voice input',
        'AI Shop Assistant for sales, stock and udhar Q&A',
        'AI Dashboard for fast movers, slow movers and dead stock',
        'AI voice udhar payment reminder calls',
        'Barcode scanning',
        'Udhar (credit) customer accounts',
        'Stock and expiry tracking',
        'Google Drive sync between PC and phone',
        '22+ Indian regional languages',
        'WhatsApp and SMS bill PDF sharing',
        'Product photos on bills for returns and replacements',
        'Shop diary with camera receipts',
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: pocketBillingAiSeo.title,
      description: pocketBillingAiSeo.description,
      url,
      isPartOf: {
        '@type': 'WebSite',
        name: 'RestroAI',
        url: absoluteUrl('/'),
      },
      about: {
        '@type': 'Thing',
        name: 'Retail and kirana shop billing software in India',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is PocketBillingAI?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'PocketBillingAI is billing and inventory software built for Indian kirana shops, retail stores, and small restaurants. It works offline on desktop (Windows/Mac) and Android, with GST reports, udhar khata, stock tracking, and AI speech billing.',
          },
        },
        {
          '@type': 'Question',
          name: 'Does PocketBillingAI work offline?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes. PocketBillingAI is offline-first. You can bill customers without internet. Optional Google Drive sync keeps your shop data backed up between devices.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is PocketBillingAI GST compliant?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes. PocketBillingAI includes HSN codes, CGST/SGST/IGST split, GSTR-1 and GSTR-3B style reports, and export to Excel or PDF for your CA.',
          },
        },
        {
          '@type': 'Question',
          name: 'How much does PocketBillingAI cost?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'PocketBillingAI plans start from ₹500 per month with all features included. Visit restroai.in/pocketbillingai for current pricing and a free trial.',
          },
        },
      ],
    },
  ];
}

export const pocketBillingAiPrivacySeo = {
  title: 'PocketBillingAI Privacy Policy | RestroAI',
  description: 'Privacy policy for PocketBillingAI billing app — how RestroAI handles your shop data, offline storage, and optional Google Drive sync.',
  canonical: absoluteUrl('/pocketbillingai/privacy-policy'),
  ogImage: OG_IMAGE,
};

export const pocketBillingAiTermsSeo = {
  title: 'PocketBillingAI Terms & Conditions | RestroAI',
  description: 'Terms and conditions for using PocketBillingAI shop billing software by RestroAI.',
  canonical: absoluteUrl('/pocketbillingai/terms'),
  ogImage: OG_IMAGE,
};
